import { initials } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import coverSrc from 'assets/img/generic/cover-min.jpg';
import Avatar from 'components/common/Avatar';
import Background from 'components/common/Background';
import CapoclasseCrown from 'components/fantaclasse/CapoclasseCrown';
import { useUser } from 'context/UserContext';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ProfileSettings from './ProfileSettings';
import DangerZone from './DangerZone';
import TeamSettings from './TeamSettings';
import ClassroomSettings from './ClassroomSettings';
import { getClassroomData } from 'api/classroomApi';
import { useQuery } from '@tanstack/react-query';
import Loading from 'pages/components/Loading';
import { titler } from 'helpers/titler';

const Account = () => {
  titler('Account');
  const user = useUser();
  const userProfilePic = createAvatar(initials, {
    seed: user?.username,
    size: 100,
    backgroundColor: ['2362b6']
  }).toDataUriSync();

  const { isLoading, data: classroom } = useQuery({
    queryKey: ['classroomData'],
    queryFn: getClassroomData,
    enabled: !!user.classroomCode
  });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Card className="mb-3">
        <Card.Header
          className="position-relative mb-7"
          style={{ minHeight: '15vh' }}
        >
          <Background image={coverSrc} className="rounded-3 rounded-bottom-0" />
          <Avatar
            size="5xl"
            className="avatar-profile"
            src={userProfilePic}
            mediaClass="img-thumbnail shadow-sm"
          />
        </Card.Header>
        <Card.Body>
          <Row>
            <Col lg={8}>
              <h4 className="mb-1">
                {user.username}
                {user.prefect && (
                  <CapoclasseCrown placement="right" className="ms-2 fs-8" />
                )}
              </h4>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Row className="g-3">
        <Col lg={8}>
          <ProfileSettings />
          {user.team.name && <TeamSettings team={user.team} />}
          {user.classroomCode && (
            <ClassroomSettings classroom={classroom} prefect={user.prefect} />
          )}
        </Col>
        <Col lg={4}>
          <div className="sticky-sidebar">
            <DangerZone />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Account;
